module.exports = __webpack_public_path__ + "static/img/xfy.28a8dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/introduce/images/xfy.png
// module id = rQTI
// module chunks = 21